import apiRequestService from '@/commonProject/service/apiRequestService';

export default class UserRepository {
    /**
     * ユーザー情報取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async getUserApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/usr', requestBody, idToken);
        return result;
    }
}
